// extracted by mini-css-extract-plugin
export var clauseRow = "_df-6";
export var emptyState = "_df-d";
export var filterContent = "_df-a";
export var filterGroup = "_df-1";
export var filterGroupContainer = "_df-0";
export var nestedGroup = "_df-2";
export var nestedGroupContent = "_df-b";
export var nestedGroupDepth1 = "_df-3";
export var nestedGroupDepth2 = "_df-4";
export var nestedGroupDepth3 = "_df-5";
export var nestedGroupEmpty = "_df-c";
export var operatorAnd = "_df-8";
export var operatorOr = "_df-9";
export var operatorToggle = "_df-7";
export var removeGroupButton = "_df-e";